import { Permissions } from "../../models/enums/permissions";
import { getApplicationStore } from "../../store/configure-store";
import { validatePermission } from "./validate-permission";

interface IProps {
    requiredPermissions : Permissions[];
}

export function hasPermission(props: IProps) {

    let isAuthed : boolean|undefined = false;

    try{
        const store = getApplicationStore();
        const userPermissions = store.getState().userdata.user.permissions;
        const { requiredPermissions } = props;

        isAuthed = validatePermission({
            currentPermissions  : userPermissions,
            requiredPermissions : requiredPermissions
        })
    }
    catch{}

    return isAuthed;
}
